import React from 'react';
import { StatusView } from 'src/components/StatusView/StatusView';
import { applicationsStatusInfoMap } from 'src/pages/ApplicationsPage/ApplicationsStatusInfoMap';
import { ApplicationStatus } from 'src/stores/ApplicationsStore/ApplicationsStore.types';

export type LoanApplicationStatusProps = {
    status?: ApplicationStatus | string;
    className?: string;
};

export const LoanApplicationStatus: React.FC<LoanApplicationStatusProps> = ({
    status,
    className,
}) => {
    if (!status) {
        return null;
    }

    return (
        <StatusView
            status={status}
            statusMap={applicationsStatusInfoMap}
            className={className}
        />
    );
};
